import gql from 'graphql-tag';
import BASE_USER_FRAGMENT from 'graph/fragments/user';

const CREATE_USER = gql`
  mutation createUser($data: UserCreateInput!, $upsert: Boolean = false) {
    createUser(data: $data, upsert: $upsert) {
      ...BaseUser
    }
  }
  ${BASE_USER_FRAGMENT}
`;

export default CREATE_USER;
